var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProductSection',{attrs:{"title":_vm.$t('products.layout.titles.layoutOptions')}},[_c('v-checkbox',{attrs:{"label":_vm.$t('products.layout.labels.rotateAt90Degrees'),"value":_vm.rotate},on:{"change":_vm.setRotate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }